import TripsDataTable from "Pages/TripsPage/TripsDataTable";
import React from "react";

const TripsComp = ({ code }) => {
  const url = `/front/trips`;
  return <TripsDataTable taxiCode={code} link={url} />;
};

export default TripsComp;
